import { ApolloLink, Observable, Operation, FetchResult } from '@apollo/client/core';
import { print } from 'graphql';
import { CapacitorHttp, HttpResponse } from '@capacitor/core';

export class CapacitorHttpLink extends ApolloLink {
  constructor(private uri: string) {
    super();
  }

  public override request(operation: Operation): Observable<FetchResult> {
    return new Observable((observer) => {
      const { query, variables, operationName } = operation;

      const body = {
        query: print(query),
        variables,
        operationName,
      };

      const headers = operation.getContext()['headers'] || {};

      // Use Capacitor's native HTTP to bypass CORS
      CapacitorHttp.post({
        url: this.uri,
        headers: {
          'Content-Type': 'application/json',
          ...headers,
        },
        data: body,
      })
        .then((response: HttpResponse) => {
          observer.next(response.data);
          observer.complete();
        })
        .catch((error) => {
          observer.error(error);
        });
    });
  }
}